export default __webpack_public_path__ + "static/media/briefcase.e7e47d0e.svg";